import React, { useEffect, useState } from "react";
import {
  Typography,
  Grid,
  Card,
  CardContent,
  Box,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import { RiShare2Line, RiShareForwardFill } from "react-icons/ri";

import { Link, useNavigate } from "react-router-dom";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllCourse } from "../../redux/slices/studentSlice";
import { getImageUrl } from "../../utils/helpFunction";
import LoadingSpinner from "../../component/shimmer/LoadingSpinner";

const CoursesReferral = ({ partner }) => {
  const dispatch = useDispatch();
  const { course: courses, loading } = useSelector((state) => state?.student);

  const userData = useSelector((state) => state.user.data);

  // Get user from session storage
  const storedUser = JSON.parse(sessionStorage.getItem("user"));
  const isPartner = storedUser?.role === "partner";
  const partnerId = isPartner ? storedUser.userId : null;

  useEffect(() => {
    if (!courses || courses.length === 0) {
      dispatch(fetchAllCourse());
    }
  }, [dispatch, courses]);

  const [isImageLoading, setIsImageLoading] = useState(true);

  // Function to generate course URL
  // const generateCourseUrl = (courseId) =>
  //   partnerId
  //     ? `${window.location.origin}/student/course/${courseId}?ref=${partnerId}`
  //     : `${window.location.origin}/student/course/${courseId}`;

  const generateCourseUrl = (courseId) =>
    partnerId
      ? `${window.location.origin}/student/course/${courseId}?ref=${partnerId}`
      : `${window.location.origin}/student/course/${courseId}?courseId=${courseId}`;

  const handleShare = async (course) => {
    const courseUrl = generateCourseUrl(course._id);
    if (navigator.share) {
      try {
        await navigator.share({
          title: `Check out this course: ${course.title}`,
          url: courseUrl,
        });
      } catch (error) {
        console.error("Error sharing", error);
      }
    } else {
      navigator.clipboard.writeText(courseUrl);
      alert("Referral link copied to clipboard!");
    }
  };

  return (
    <Grid container spacing={2}>
      {loading ? (
        <LoadingSpinner />
      ) : (
        courses?.map((course) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={3}
            key={course._id}
            mt={2}
            sx={{ cursor: "pointer" }}
          >
            <Card
              //   onClick={() => navigate(`/student/course/${course._id}`)}
              elevation={4}
              sx={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                borderRadius: 2,
                boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.1)",
                transition: "transform 0.2s ease-in-out",
                "&:hover": { transform: "translateY(-10px)" },
              }}
            >
              <Link
                // to={`/student/course/${course._id}`}
                className="relative block"
              >
                <div className="relative w-full aspect-video rounded-t-lg overflow-hidden bg-gray-200">
                  <img
                    src={
                      getImageUrl(course.imagePublicId) ||
                      "https://via.placeholder.com/400x200"
                    }
                    alt={course.title}
                    className="w-full h-full object-cover"
                    onLoad={() => setIsImageLoading(false)}
                    onError={() => setIsImageLoading(false)}
                  />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-14 h-14 bg-black bg-opacity-75 rounded-full flex items-center justify-center shadow-lg">
                      <PlayArrowIcon
                        sx={{ fontSize: "40px", color: "white" }}
                      />
                    </div>
                  </div>
                </div>
              </Link>

              <CardContent sx={{ flexGrow: 1, padding: 1 }}>
                <Typography variant="h6" component="h2" fontWeight="bold">
                  {course.title.length > 50
                    ? `${course.title.substring(0, 50)}...`
                    : course.title}
                </Typography>
                <Box mt={1} sx={{ display: "flex", alignItems: "center" }}>
                  <Typography
                    variant="body1"
                    fontWeight="bold"
                    sx={{ color: "#303141" }}
                  >
                    ₹{course.discountedPrice}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      textDecoration: "line-through",
                      color: "#808191",
                      fontSize: "0.875rem",
                      pl: 0.6,
                    }}
                  >
                    ₹{course.price}
                  </Typography>
                  <Typography
                    variant="body2"
                    fontWeight="bold"
                    sx={{ color: "#FF6F61", fontSize: "0.750rem", pl: 0.5 }}
                  >
                    ({course.discountPercentage}% OFF)
                  </Typography>
                </Box>
              </CardContent>

              {/* Show Share Button Only for Partners */}
              {isPartner && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    p: 1,
                  }}
                >
                  <Typography
                    title="Commission on Course"
                    sx={{
                      color: "black", // Gold color for an attractive look
                      p: 1,
                      mx: 1,
                      borderRadius: 1,
                      backgroundColor: "rgba(255, 215, 0, 0.2)", // Light gold background
                      fontWeight: "bold",
                      fontSize: "1rem",
                    }}
                  >
                    💰 Earn ₹
                    {Math.floor(
                      (partner?.commissionRate * course?.discountedPrice) / 100
                    )}
                    per sale!
                  </Typography>
                  <IconButton
                    title="Share Course Referral Link"
                    onClick={() => handleShare(course)}
                    color="primary"
                    sx={{ ":hover": { bgcolor: "lightblue" } }}
                  >
                    <RiShareForwardFill sx={{ fontSize: "2rem", p: 1 }} />
                  </IconButton>
                </Box>
              )}
            </Card>
          </Grid>
        ))
      )}
    </Grid>
  );
};

export default CoursesReferral;
